import { all } from 'redux-saga/effects';
import generalSagas from './general/sagas';

export default function* appSaga() {
    yield all([generalSagas()]);
}
